import { useLocation } from "react-router-dom";
import TermsThai from "./TermsThai";
import TermsEnglish from "./TermsEnglish";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const TermsAndConditions = () => {
  let query = useQuery();

  let _returnBody = null;
  try {
    let languages = query.get("languages");
    switch (languages) {
      case "th":
        _returnBody = TermsThai;
        break;
      default:
        // default when languages not found
        _returnBody = TermsEnglish;
        break;
    }
  } catch (error) {
    // console.error("error")
    //use when got error and return default page
    _returnBody = TermsEnglish;
  }
  return _returnBody();
};

export default TermsAndConditions;
